export default ({ pageState: { editorBlocks } }) => {
  const modifiedBlocks = { ...editorBlocks };
  for (const blockId of Object.keys(editorBlocks)) {
    const block = editorBlocks[blockId];

    if (
      block.data.markAsNewUntil &&
      Date.parse(block.data.markAsNewUntil) > Date.now()
    ) {
      modifiedBlocks[blockId] = { ...block, isSelected: true };
    }
  }

  return { editorBlocks: modifiedBlocks };
};
